import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import NavbarLayout from "./components/Layout/NavbarLayout";
import ChatBot from "./components/Chatbot/ChatBot";
import Home from "./components/Home/Home";
import About from "./components/WWD/About";
import OurStory from "./components/OurStory/OurStory";
import MissionVision from "./components/MissionVision/MissionVision";
import Contact from "./components/Contact/Contact";
import ProjectKUL from "./components/ProjectKUL/ProjectKUL";
import Footer from "./components/Footer/Footer";
import Opportunities from "./components/Opportunities/Opportunities";
import Inspirations from "./components/Inspirations/Inspirations";
import Engagements from "./components/Engagements/Engagements";
import ComNutrition from "./components/Engagements/ComNutrition/ComNutrition";
import Education from "./components/Engagements/Education/Education";
import Arts from "./components/Engagements/Arts/Arts";
import Hangouts from "./components/Engagements/Hangouts/Hangouts";
import WKW from "./components/Engagements/WKW/WKW";
import PlantKindness from "./components/Engagements/PlantKindness/PlantKindness";
import KCCollege from "./components/Engagements/KCCollege/KCCollege";
import KindnessMusic from "./components/Engagements/KindnessMusic/KindnessMusic";
import Zumba from "./components/Engagements/Zumba/Zumba";
import Upstander from "./components/Engagements/Upstander/Upstander";
import KindnessJam from "./components/Engagements/KindnessJam/KindnessJam";
import Beats from "./components/Engagements/Beats/Beats";
import Musical from "./components/Engagements/Musical/Musical";
import DanceKindness from "./components/Engagements/DanceKindness/DanceKindness";
import Kohinoor from "./components/Engagements/Kohinoor/Kohinoor";
import KindnessCircles from "./components/Engagements/KindnessCircles/KindnessCircles";
import DonateAToi from "./components/Engagements/DonateAToi/DonateAToi";
import Nashta from "./components/Engagements/Nashta/Nashta";
import Carnival from "./components/Engagements/Carnival/Carnival";
import CupofKindness from "./components/Engagements/CupofKindness/CupofKindness";
import GoBananas from "./components/Engagements/GoBananas/GoBananas";
import FoodDistribution from "./components/Engagements/FoodDistribution/FoodDistribution";
import Gallery from "./components/Gallery/Gallery";
import Newsroom from "./components/Newsroom/Newsroom";
import Collaborations from "./components/Collaborations/Collaborations";
import SYT from "./components/SYT/SYT";
import WKM from "./components/WKM/WKM";
import OurTeam from "./components/OurTeam/OurTeam";
import Donate from "./components/Donate/Donate";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import KindnessShop from "./components/KindnessShop/KindnessShop";
import DaanUtsav from "./components/Engagements/DaanUtsav/DaanUtsav";
import DaanUtsavProject1 from "./components/Engagements/DaanUtsavProject1/DaanUtsavProject1";
import DaanUtsavProject2 from "./components/Engagements/DaanUtsavProject2/DaanUtsavProject2";
import KindnessProm from "./components/Engagements/KindnessProm/KindnessProm";
import WheelchairCricket from "./components/Engagements/WheelchairCricket/WheelchairCricket";
import AgatsuShowcase from "./components/Engagements/AgatsuShowcase/AgatsuShowcase";
import CEP from "./components/CEP/CEP";
import TestimonialsPage from "./components/Testimonials/TestimonialsPage";
import ImpactHub from "./components/Dashboard/ImpactHub";
import Programs from "./components/Programs/Programs";
import VolunteeringPlaceholder from "./components/Volunteering/VolunteeringPlaceholder";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./components/ui/Toast";
import VolunteerLogin from "./components/VolunteerAuth/VolunteerLogin";
import ProtectedRoute from "./components/VolunteerAuth/ProtectedRoute";
import StudentDashboard from "./components/VolunteerAuth/StudentDashboard";
import AdminDashboard from "./components/VolunteerAuth/AdminDashboard";
import AdminAttendance from "./components/VolunteerAuth/AdminAttendance";
import AdminStudents from "./components/VolunteerAuth/AdminStudents";
import AdminColleges from "./components/VolunteerAuth/AdminColleges";
import ResetPassword from "./components/VolunteerAuth/ResetPassword";
import AdminEvents from "./components/VolunteerAuth/AdminEvents";

const AppContent = () => (
  <>
    <NavbarLayout>
      <ChatBot />
      <Routes>
        <Route path="/" element={<Home />} />
        {/* About */}
        <Route path="/wwd" element={<About />} />
        <Route path="/ourstory" element={<OurStory />} />
        <Route path="/wkm" element={<WKM />} />
        <Route path="/ourteam" element={<OurTeam />} />
        <Route path="/contactus" element={<Contact />} />
        <Route path="/collaborations" element={<Collaborations />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/missionvision" element={<MissionVision />} />
        {/* Volunteer */}
        <Route path="/opportunities" element={<Opportunities />} />
        <Route path="/volunteering" element={<VolunteeringPlaceholder />} />
        {/* Volunteer Auth */}
        <Route path="/login" element={<VolunteerLogin />} />
        <Route path="/volunteer/login" element={<VolunteerLogin />} />
        <Route path="/admin/login" element={<VolunteerLogin />} />
        <Route path="/volunteer/dashboard" element={
          <ProtectedRoute role="student"><StudentDashboard /></ProtectedRoute>
        } />
        <Route path="/volunteer/attendance" element={
          <ProtectedRoute role="student"><StudentDashboard /></ProtectedRoute>
        } />
        {/* Admin Routes */}
        <Route path="/admin/dashboard" element={
          <ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>
        } />
        <Route path="/admin/attendance" element={
          <ProtectedRoute role="admin"><AdminAttendance /></ProtectedRoute>
        } />
        <Route path="/admin/students" element={
          <ProtectedRoute role="admin"><AdminStudents /></ProtectedRoute>
        } />
        <Route path="/admin/colleges" element={
          <ProtectedRoute role="admin"><AdminColleges /></ProtectedRoute>
        } />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/admin/events" element={ <ProtectedRoute role="admin"> <AdminEvents /> </ProtectedRoute> }
        />
        <Route path="/syt" element={<SYT />} />
        {/* Programs hub */}
        <Route path="/programs" element={<Programs />} />
        {/* Merchandise */}
        <Route path="/shop" element={<KindnessShop />} />
        {/* CEP */}
        <Route path="/cep" element={<CEP />} />
        {/* Donate */}
        <Route path="/donate" element={<Donate />} />
        {/* Engagements */}
        <Route path="/engagements" element={<Engagements />} />
        <Route path="/engagements/nutrition" element={<ComNutrition />} />
        <Route path="/engagements/nutrition/plantkindness" element={<PlantKindness />} />
        <Route path="/engagements/nutrition/nashta" element={<Nashta />} />
        <Route path="/engagements/nutrition/cupofkindness" element={<CupofKindness />} />
        <Route path="/engagements/WKW/cupofkindness" element={<CupofKindness />} />
        <Route path="/engagements/nutrition/gobananas" element={<GoBananas />} />
        <Route path="/engagements/nutrition/fooddistribution" element={<FoodDistribution />} />
        <Route path="/engagements/WKW/fooddistribution" element={<FoodDistribution />} />
        <Route path="/engagements/education" element={<Education />} />
        <Route path="/engagements/arts" element={<Arts />} />
        <Route path="/engagements/arts/musical" element={<Musical />} />
        <Route path="/engagements/arts/zumba" element={<Zumba />} />
        <Route path="/engagements/arts/kindnessjam" element={<KindnessJam />} />
        <Route path="/engagements/WKW/kindnessjam" element={<KindnessJam />} />
        <Route path="/engagements/arts/beats" element={<Beats />} />
        <Route path="/engagements/WKW/beats" element={<Beats />} />
        <Route path="/engagements/arts/kindnessmusic" element={<KindnessMusic />} />
        <Route path="/engagements/arts/dancekindness" element={<DanceKindness />} />
        <Route path="/engagements/WKW/dancekindness" element={<DanceKindness />} />
        <Route path="/engagements/WKW/carnival" element={<Carnival />} />
        <Route path="/engagements/hangouts" element={<Hangouts />} />
        <Route path="/engagements/hangouts/upstander" element={<Upstander />} />
        <Route path="/engagements/WKW" element={<WKW />} />
        <Route path="/engagements/education/KCCollege" element={<KCCollege />} />
        <Route path="/engagements/education/kindnesscircles" element={<KindnessCircles />} />
        <Route path="/engagements/education/kohinoor" element={<Kohinoor />} />
        <Route path="/engagements/education/donateatoi" element={<DonateAToi />} />
        <Route path="/engagements/daanutsav" element={<DaanUtsav />} />
        <Route path="/engagements/daanutsav/daanutsavproject1" element={<DaanUtsavProject1 />} />
        <Route path="/engagements/daanutsav/daanutsavproject2" element={<DaanUtsavProject2 />} />
        <Route path="/engagements/WKW/kindnessprom" element={<KindnessProm />} />
        <Route path="/engagements/WKW/wheelchaircricket" element={<WheelchairCricket />} />
        <Route path="/engagements/WKW/agatsushowcase" element={<AgatsuShowcase />} />
        {/* Events / Gallery */}
        <Route path="/gallery" element={<Gallery />} />
        {/* Stories */}
        <Route path="/inspirations" element={<Inspirations />} />
        <Route path="/newsroom" element={<Newsroom />} />
        {/* Campaigns */}
        <Route path="/project-kul" element={<ProjectKUL />} />
        {/* Testimonials */}
        <Route path="/testimonials" element={<TestimonialsPage />} />
        {/* Impact Reports */}
        <Route path="/impact" element={<ImpactHub />} />
        <Route path="*" element={<Navigate to="/volunteer/login" replace />} />
      </Routes>
      <Footer />
      {/* <ChatBubble /> */}
    </NavbarLayout>
  </>
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <AppContent />
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;